const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || '').trim();

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

async function postWithRetries(
  path: string,
  body: object,
  options: { keepalive?: boolean; retries?: number; prolificId: string }
): Promise<void> {
  if (!API_BASE_URL) return;
  const retries = options.retries ?? 3;
  const url = `${API_BASE_URL}${path}`;
  for (let attempt = 0; attempt < retries; attempt++) {
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'prolific-id': options.prolificId,
        },
        body: JSON.stringify(body),
        keepalive: options.keepalive === true,
      });
      if (res.ok) return;
    } catch {
      /* retry */
    }
    if (attempt < retries - 1) {
      await sleep(400 * (attempt + 1));
    }
  }
}

/** First page load with participant ID — anchors study start before /setup creates Player. Idempotent. */
export function recordStudyStart(prolificId: string | null | undefined): void {
  if (!prolificId) return;
  void postWithRetries(
    '/studyTiming/start',
    { clientStartTimeMs: Date.now() },
    { keepalive: false, retries: 3, prolificId }
  );
}

/**
 * Final thank-you (or incomplete exit) — persists wall-clock duration on Player.
 * `keepalive` helps delivery if the participant navigates away quickly after load.
 */
export function recordStudyComplete(prolificId: string | null | undefined): void {
  if (!prolificId) return;
  void postWithRetries('/studyTiming/complete', {}, { keepalive: true, retries: 3, prolificId });
}
